/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_EmpfaengerInputs */

const de__field_empfaenger = /** @type {(inputs: _Field_EmpfaengerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfänger:in`)
};

/**

* @param {_Field_EmpfaengerInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_empfaenger = /** @type {((inputs?: _Field_EmpfaengerInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_EmpfaengerInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_empfaenger(inputs)
});